var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sTooltip',{attrs:{"border":false,"content":_vm.text,"data-qa":_vm.data_qa,"placement":"bottom","type":"white"}},[_c('sIcon',{attrs:{"color":_vm.color,"size":"12","type":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }